export class Margin {
  public id: number;
  public name: string;
  public margintop: number;
  public marginbottom: number;
  public marginleft: number;
  public marginright: number;

  constructor(id: number, name: string, margintop: number, marginbottom: number, marginleft: number, marginright: number) {
    this.id = id;
    this.name = name;
    this.margintop = margintop;
    this.marginbottom = marginbottom;
    this.marginleft = marginleft;
    this.marginright = marginright;
  }
}
